import { ChangeDetectorRef, Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, map, Observable } from 'rxjs';
import { Blueprint } from 'src/app/models/blueprints/blueprint';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { DeploymentClass } from 'src/app/models/instance-class';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { translate } from '@jsverse/transloco';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ,
  },
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE,
  }
];

@Component({
    selector: 'app-service-definition',
    templateUrl: './service-definition.component.html',
    styleUrls: ['./service-definition.component.scss'],
    standalone: false
})
export class ServiceDefinitionComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  Permissions = Permissions;
  PermissionKeys = PermissionKeys;
  tenantId: string;
  serviceDefinitionList: any;
  solution: any;
  tenant: any;
  isAMR: boolean;
  dataLoaded = false;
  instances: any;
  isLive: boolean;
  serviceVersionsInfo: SolutionVersionsInfo;
  solutionVersions: any[];
  latestReleaseVersion: any;
  initialLoader = true;
  pageSize: number;
  pageNumber = 1;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  filterTenant: any;
  searchText: any;
  blueprint: any;
  permissionsMap: { [key: string]: boolean };
  solutionsData = [];
  isServiceDefinitionDataLoaded = false;
  initialBluePrints:any;
  initialsolutionVersions:any;
  isExternalTenant: boolean;

  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED, DeployStatus.TEST_FAILED];
     solutionNameFromSolution: any;
  solutionsMapped: any;
  dropdownsList: { title: string; placeholder?: string; options?: any; }[];
  filteredColumns: any;
  selectedSolution: any;
  filterEnable: boolean;
  selectedSolutionId: string | undefined;
  constructor(private activatedRoute: ActivatedRoute, private blueprintsService: BlueprintsService, private solutionsService: SolutionsService,
    private solutionVersionsService: SolutionVersionsService, private tenantService: TenantService, private instanceService: InstancesService,
    private router: Router, private authService: AuthService, private sidenavService: SidenavService, private toastrService: CustomToastrService, private cdr: ChangeDetectorRef,
    public permissionsService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.tenantService.tenant$.subscribe((tenant) => {
      this.isExternalTenant = tenant?.origin === TenantOrigin.EXTERNAL? true : false;
    });
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    if (!this.permissionsMap[PermissionKeys.BLUEPRINT_READ]) {
      this.router.navigate(['/', this.tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    const solution = localStorage.getItem('tenantSerDefSolutionValue');
    if (solution) {
      this.selectedSolution = solution;
    }
    const solutionId = localStorage.getItem('tenantSerDefSolutionId');
    if (solution) {
      this.selectedSolutionId = solutionId;
    }
    this.getBlueprints();
    this.getSolutions();
    this.getTenants(this.tenantId);
  }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
  }

  getBlueprints(): void {
    this.initialLoader = true;
    this.serviceDefinitionList = [];
    this.pageIndex = 0;
    this.filterTenant = [];
    if(this.selectedSolutionId) {
    this.blueprintsService.getBlueprintsForSolution(this.selectedSolutionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: any) => {
        this.initialsolutionVersions=result;
        this.pageLoad(result);
      });
    } else {
      this.blueprintsService.getBlueprints(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: any) => {
        this.initialBluePrints=result;
        this.pageLoad(result);
      }, (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }
  }

  pageLoad(result): void {
  result = result.sort((a,b) => b?.dateCreated?.localeCompare(a?.dateCreated));
      this.initialLoader = false;
      this.filterTenant = result.filter(item => item.tenantId == this.tenantId);
      this.blueprint = this.filterTenant;
      this.serviceDefinitionList = this.filterTenant?.slice(this.pageIndex, this.paginationSize);
      if(this.serviceDefinitionList.length < 10) {
      this.loadData();
      } 
    }

  getSolutions(): void {
    this.solutionsService.getSolutions()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
      this.solutionsMapped = Object.keys(data).map(key => ({id: data[key].id, value: data[key].name, selected: false}));
      this.solutionsMapped = this.solutionsMapped.sort((a,b) => (a.value.toLowerCase() < b.value.toLowerCase()) ? -1 : 1);
      this.filterEnable = true;
      }
      this.dropdownsList = [
        {
          title: 'solution',
          placeholder: 'Select Solution',
          options: this.solutionsMapped
        }
      ];
    });
  }

  closeMenu(data): void {
    this.selectedSolution = undefined;
    this.selectedSolutionId = undefined;
    localStorage.removeItem('tenantSerDefSolutionValue');
    localStorage.removeItem('tenantSerDefSolutionId');
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  filteredColumnsFunction(data): void {
    if(this.selectedSolution === data) {
      this.selectedSolution = undefined;
      this.selectedSolutionId = undefined;
      this.resetValue(this.dropdownsList[0]);
    }
    this.getBlueprints();
  }

  resetValue(closedItem): void {
    this.selectedSolution = undefined;
    this.selectedSolutionId = undefined;
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
    localStorage.removeItem('tenantSerDefSolutionValue');
    localStorage.removeItem('tenantSerDefSolutionId');
  }

  resetFilter(): void {
    this.selectedSolution = undefined;
    this.selectedSolutionId = undefined;
    this.sidenavService.searchFilter.next('data');
    localStorage.removeItem('tenantSerDefSolutionValue');
    localStorage.removeItem('tenantSerDefSolutionId');
    this.resetAllValues();
    this.getBlueprints();
  }

  resetAllValues(): void {
    this.dropdownsList?.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
   localStorage.removeItem('tenantSerDefSolutionValue');
  localStorage.removeItem('tenantSerDefSolutionId');
  }

  

  filterColumns(): void {
    if (this.selectedSolution) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.id === this.selectedSolution) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.SERVICE_DEFINITION'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      solution: this.dropdownsList[0]?.options,
      page: 'service_def'
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns) {
          this.initialLoader = true;
          this.serviceDefinitionList = [];
          this.filteredColumns = filteredColumns;
          if(filteredColumns[0] !== ''){
            this.selectedSolution = filteredColumns[0]?.value;
          }
          if (filteredColumns[0]?.id) {
            this.blueprintsService.getBlueprintsForSolution(filteredColumns[0].id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result: any) => {
              localStorage.setItem('tenantSerDefSolutionValue', filteredColumns[0].value);
              localStorage.setItem('tenantSerDefSolutionId', filteredColumns[0].id);
              this.pageLoad(result);
            }); 
          } else {
            this.blueprintsService.getBlueprintsForSolution()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result: any) => {
              localStorage.setItem('tenantSerDefSolutionValue', '');
              localStorage.setItem('tenantSerDefSolutionId', '');
              this.pageLoad(result);
            }); 
          }          
        }
      });
  }


  loadData(): void {
    if (this.serviceDefinitionList && !this.serviceDefinitionList[0]?.version) {
      this.dataLoaded = false;
    }
    this.serviceDefinitionList.forEach( blueprint => {
      const obj = {
        blueprintId: blueprint.id,
        tenantId: this.tenantId
      };
      combineLatest([
        this.solutionsService.getSolutionById(blueprint.solutionId),
        this.solutionsService.getSolutionVersions(blueprint.solutionId),
        this.instanceService.getInstances(obj)
      ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([solution,solutionVersion, instances]) => {
        this.isServiceDefinitionDataLoaded = true;
        this.solutionNameFromSolution = solution;
        this.solutionVersions = solutionVersion;
        this.instances = instances?.data;
        this.isLive = this.resolveLiveStatus(this.instances);
        this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(solutionVersion, this.solutionVersions, this.instances);
        const liveInstance = this.instances.find(instance => instance.deploymentClass === DeploymentClass.A);

        if (liveInstance) {
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
        } else {
          const instanceLength = this.instances.length;
          const latestInstanceSolutionVersion = this.instances[instanceLength - 1]?.solutionVersionId;
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
        }
        let releaseVersionText;
        if (this.latestReleaseVersion) {
          releaseVersionText = this.latestReleaseVersion;
        } else {
          releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
        }
        this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
        if (this.instances?.length) {
          const latestSolutionId = this.instances[this.instances.length - 1]?.solutionId;
          let solutions;
          if (solution?.length) {
            solutions = solution?.find(version => version?.id == latestSolutionId);
          } else {
            solutions = solution;
          }
          blueprint.solutionName = solutions?.name;
        } else {
          blueprint.solutionName = solution?.name;
        }
        blueprint.solutionName = blueprint.solutionName ? blueprint.solutionName : 'N/A';
        blueprint.version = releaseVersionText;
        blueprint.isAMR = this.isAMR;
        this.dataLoaded = true;
      },
      (error) => {
        blueprint.solutionName = blueprint.solutionName ? blueprint.solutionName : 'N/A';
      });
    });
    if (this.serviceDefinitionList.length === 0) {
      this.dataLoaded = true;
    }
  }

  searchBlueprint(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.blueprint = this.filterTenant;
    if (this.searchText) {
      this.blueprint = this.blueprint.filter(item => item?.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.blueprint = this.filterTenant;
    }
    this.pageIndex = 0;
    this.serviceDefinitionList = this.blueprint?.slice(this.pageIndex, this.paginationSize);
    this.loadData();
  }

  getTenants(tenantId): void {
    this.tenantService.getTenants(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.tenant = data;
    });
  }

  cardClick(service) {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS , service.id]);
  }

  private resolveLiveStatus(instances: any[]): boolean {
    const live = instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      this.serviceDefinitionList = this.blueprint.slice(firstIndex, firstIndex + this.paginationSize);
      this.loadData();
    }
  }

  createServiceDefinition(): any {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, RouterSegments.SOLUTION]);
  }
}
